<template>
    <div class="otherbox">
        <!-- 案件信息 -->
        <div class="htit">
            <div style="display: flex;flex-wrap: nowrap;align-items: center;">
                <div class="h2">案件信息</div>

                <!-- <div class="person"
                    style="background-color: #1d8bfe;color: #fff;border-radius: 4px;padding: 0 12px;height: 36px;line-height: 36px;cursor: pointer;margin: 0 10px 0 20px;"
                    @click="editstepname">
                    <a-icon type="edit" :style="{ fontSize: '0.875rem', color: '#fff' }" />
                    <span style="margin-left: 0.5rem;">当前负责人：</span>
                    <span>{{ step_user_name ? step_user_name : '暂无' }}</span>
                </div> -->
                <!-- <a-button style="margin: 0 10px 0 20px;" icon="edit" @click="editstepname">当前负责人：{{ step_user_name ?
                    step_user_name : '暂无' }}
                </a-button> -->
                <!-- <a-button type="primary" icon="unordered-list" @click='AgentShow("agentbox")'>代理人</a-button> -->
            </div>
            <!-- <div style="display: flex;flex-wrap: nowrap;align-items: center;">
                <div :class="[i.is_retrial == 1 ? 'retriallight' : 'retrial']">重</div>
                <div :class="[i.in_loan == 1 ? 'loanlight' : 'loan', 'loan-tag']">分期履行中</div>
                <div class="rts">

                    <a-button icon="edit" @click='visibleShow("CasePopUp");'
                        v-if='$common.AccAUTH(debInfo.accuser_id, "debtor:edit") && debInfo.is_clear != 1'>修改
                    </a-button>
                </div>
            </div> -->
        </div>
        <div style="padding: 20px;">
            <div class="nselectbox">
                <div class="paddingBox">
                    <a-row class="caseInput" style="align-items: center;">
                        <a-col :span="4">
                            <label>案由 : </label>
                            <span v-if="i.reason">{{ i.reason.title }}</span>
                        </a-col>
                        <a-col :span='4'>
                            <label>业务部门：</label>
                            <span v-if='i.team'>{{ i.team.title }}</span>
                        </a-col>
                        <a-col :span="4">
                            <label>金融机构：</label>
                            <span v-if='i.bank'> {{ i.bank.title }}</span>
                        </a-col>
                        <a-col :span='4'>
                            <label>当前进度：</label>
                            <span v-if='hasjdList.length > 0'>{{ hasjdList[hasjdList.length - 1].title }}</span>
                        </a-col>
                        <a-col style="display: flex;">
                            <label style="white-space: nowrap;">管辖法院：</label>
                            <Normap :tit='i.court | rCity'
                                style="overflow: hidden;white-space: nowrap; text-overflow: ellipsis;"></Normap>
                        </a-col>
                    </a-row>
                </div>
            </div>
            <div class="nselectbox">
                <div class="paddingBox">
                    <a-row type='flex' class="caseInput" style="align-items: center;">
                        <a-col :span='4'>
                            <a-button style="width: 138px;" type="primary" ghost icon="edit" @click='litigation'
                                v-if='i.is_clear != 1'>
                                <span style="color: #1d8bfe;">{{ i.cause_type == 1 ? '诉讼' : '仲裁' }}费用</span>
                            </a-button>
                        </a-col>
                        <a-col :span='4'>
                            <a-button style="width: 138px;" type="primary" ghost icon="ordered-list"
                                @click="noShow(1)"><span style="color: #1d8bfe;">案件案号</span></a-button>
                        </a-col>
                        <a-col :span='4'>
                            <a-button style="width: 138px;" type="primary" ghost icon="unordered-list"
                                @click='AgentShow("agentbox")'><span style="color: #1d8bfe;">代理人信息</span></a-button>
                        </a-col>
                        <a-col :span='4'>
                            <a-button style="width: 138px;" type="primary" ghost icon="tags"
                                @click="visibleShow('Compensation')"><span
                                    style="color: #1d8bfe;">本案代偿明细</span></a-button>
                        </a-col>
                        <a-col :span='4'>
                            <a-button style="width: 138px;" :type="i.has_loan ? 'primary' : 'default'"
                                :class="[i.has_loan ? 'primary' : 'default']" :ghost="i.has_loan"
                                :disabled='!i.has_loan' icon="money-collect" @click="dbclick(i)">
                                <span>分期信息</span>
                            </a-button>
                        </a-col>
                        <a-col :span='4'>
                            <a-button style="width: 138px;" :type="i.has_payee ? 'primary' : 'default'"
                                :class="[i.has_payee ? 'primary' : 'default']" :ghost="i.has_payee"
                                :disabled='!i.has_payee' icon="transaction" @click="collectionClick(i)">
                                <span>案款信息</span></a-button>

                        </a-col>
                    </a-row>
                </div>
            </div>

            <!-- <div class="nselectbox">
                <div class="paddingBox">
                    <a-row class="caseInput">
                        <a-col :span='24'>
                            <label style="white-space: nowrap;">特殊备注：</label>
                            <div style="display: flex;flex-direction: column;width: 100%;gap: 5px;">
                                <div v-for="(item, index) in i.notes" :key="index">
                                    <span style="display: block;word-break: break-all;" v-if='$common.AccAUTH(i.accuser_id, (!i.note ? "cause:innerCommnet:add" :
                                        ($store.state.cause.invaild == 0 ? "cause:innerCommnet:read" :
                                            "cause:invalid:innerComment:read")))'>
                                        {{ item.created_at }} {{ item.username }}：{{ resection(item.content) }}
                                       
                                        <a v-if='(user.id == 1 && item.audit != 1) || item.audit == 0 && item.user_id == user.id && !isEdit("note", i.audit) && $common.AccAUTH(i.accuser_id, $store.state.cause.invaild == 0 ? "cause:innerComment:edit" : "cause:invaild:innerComment:edit")'
                                            href='javascript:void(0);'
                                            @click='note = JSON.parse(JSON.stringify(item)); noteVisible = true; inputChange = true'
                                            style="white-space: nowrap;margin-left:10px;">
                                            修改
                                        </a>
                                      
                                        <font color='#f00' style="margin-left:10px;white-space: nowrap;"
                                            v-if="item.audit == 1">
                                            审核中
                                        </font>
                                     
                                        <a href='javascript:void(0);' v-if="i.notes.length == index + 1"
                                            @click='note = {}; noteVisible = true; inputChange = true'
                                            style="white-space: nowrap;margin-left:10px;">
                                            新增

                                        </a>
                                    </span>

                                </div>
                                <a href='javascript:void(0);' v-if="i.notes.length == 0"
                                    @click='note = {}; noteVisible = true; inputChange = true'
                                    style="white-space: nowrap;margin-left:10px;width: 50px;">
                                    新增
                                </a>
                            </div>
                        </a-col>
                    </a-row>
                    <a-modal :visible="noteVisible" @cancel="noteVisible = false" title='特殊备注' width='480px'
                        @ok='markSub()'>
                        <a-row align='top' type='flex'>
                            <label>特殊备注：</label>
                            <div>
                                <a-textarea placeholder='请输入特殊备注' @change="textareaChange" v-model='note.content'
                                    style="width:350px;height:120px;">
                                </a-textarea>
                            </div>
                        </a-row>
                    </a-modal>
                </div>
            </div> -->
            <!-- <div class="solids"></div> -->
        </div>
        <!-- <drag-modal :visible="stepnameVisible" @cancel="close" title='更换负责人' width='330px'>
            <a-spin :spinning="loading">
            
                <div style="margin-top: 40px;">
                    <a-popconfirm :disabled="disabledShow" title="确认更换当前负责人吗?" ok-text="确定" cancel-text="取消"
                        @confirm="confirm">
                        <a-button :disabled="disabledShow" type="primary" style="width:130px;">
                            提交
                        </a-button>
                    </a-popconfirm>
                    <a-button style="margin-left: 20px;width:130px;background:#B2C9E1;color:#fff;"
                        @click='close'>取消</a-button>
                </div>
            </a-spin>
        </drag-modal> -->
        <drag-modal :visible="noVisible" @cancel="close" title="案件案号" width='450px'>
            <div style="display: flex;align-items: center;">
                <div style="width: 80px;font-weight: 600;">审判案号：</div>
                <div style="width: 260px;word-break: break-all">
                    <div style="display: flex;flex-direction: column;gap: 5px;"
                        v-if="i.no_view.sqbq_ruline_no || i.no_view.la_no || i.no_view.la_no_es || i.no_view.la_no_zs">
                        <div v-if="i.no_view.sqbq_ruline_no">保全：{{ convertToFullwidthBrackets(i.no_view.sqbq_ruline_no)
                            }}
                        </div>
                        <div v-if="i.no_view.la_no">一审：{{ convertToFullwidthBrackets(i.no_view.la_no) }}</div>
                        <div v-if="i.no_view.la_no_es">二审：{{ convertToFullwidthBrackets(i.no_view.la_no_es) }}</div>
                        <div v-if="i.no_view.la_no_zs"><span>再审：</span><span>{{
                            convertToFullwidthBrackets(i.no_view.la_no_zs) }}</span></div>
                    </div>
                    <div v-else>暂无</div>
                </div>
            </div>
            <div style="display: flex;align-items: center;margin-top: 20px;">
                <div style="width: 80px;font-weight: 600;">执行案号：</div>
                <div style="width: 260px;">
                    <div style="display: flex;flex-direction: column;gap: 5px;"
                        v-if="i.no_view.sqbq_preservation_no || i.no_view.la_no_zx || i.no_view.zh_no">
                        <div v-if="i.no_view.sqbq_preservation_no">
                            {{ convertToFullwidthBrackets(i.no_view.sqbq_preservation_no) }}</div>
                        <div v-if="i.no_view.la_no_zx">{{ convertToFullwidthBrackets(i.no_view.la_no_zx) }}</div>
                        <div v-if="i.no_view.zh_no">{{ convertToFullwidthBrackets(i.no_view.zh_no) }}</div>
                        <div v-if="i.no_view.zh_no_1">{{ convertToFullwidthBrackets(i.no_view.zh_no_1) }}</div>
                        <div v-if="i.no_view.zh_no_2">{{ convertToFullwidthBrackets(i.no_view.zh_no_2) }}</div>
                        <div v-if="i.no_view.zh_no_3">{{ convertToFullwidthBrackets(i.no_view.zh_no_3) }}</div>
                        <div v-if="i.no_view.zh_no_4">{{ convertToFullwidthBrackets(i.no_view.zh_no_4) }}</div>
                        <div v-if="i.no_view.zh_no_5">{{ convertToFullwidthBrackets(i.no_view.zh_no_5) }}</div>
                        <div v-if="i.no_view.zh_no_6">{{ convertToFullwidthBrackets(i.no_view.zh_no_6) }}</div>
                        <div v-if="i.no_view.zh_no_7">{{ convertToFullwidthBrackets(i.no_view.zh_no_7) }}</div>
                        <div v-if="i.no_view.zh_no_8">{{ convertToFullwidthBrackets(i.no_view.zh_no_8) }}</div>
                        <div v-if="i.no_view.zh_no_9">{{ convertToFullwidthBrackets(i.no_view.zh_no_9) }}</div>
                    </div>
                    <div v-else>暂无</div>
                </div>
            </div>
        </drag-modal>
        <agentinfoModel ref="agentbox" v-if="dislog.agentbox"></agentinfoModel>
    </div>
</template>
<script>
// import Share from '../btns/share.vue'
import { mapGetters } from 'vuex'
import { accUserList, causeStStepUser } from '@/server/user'
import { addNote, modifyNote } from "@/server/api"
import agentinfoModel from "@/page/ly/dislog/agentinfoModel"

import { convertToFullwidthBrackets } from "@/assets/js/caseNumber"

export default {
    components: {
        // Share,
        agentinfoModel
    },
    props: {
        i: Object,
        hasjdList: Array,
        index: Number,
    },
    name: 'CaseInformation',
    computed: {
        ...mapGetters([
            'debInfo',
            'APIKEY',
            'dislog',
            'caselist',
        ]),
        user() {
            return this.$store.state.user
        }
    },
    watch: {
        i: {
            deep: true,
            handler(val) {
                this.$forceUpdate()
            }
        }
    },
    data() {
        return {
            twoShow: false,
            userList: [],
            outerList: [],
            list: [
                {
                    id: 1,
                    username: '1000',
                    create_time: '2020-05-05'
                }, {
                    id: 2,
                    username: '1000',
                    create_time: '2020-05-05'
                },
            ],
            noteVisible: false,
            inputChange: true,
            note: {
                content: '',
            },
            id: 1,
            step_user_id: '',
            step_user_name: '',
            stepnameVisible: false,
            disabledShow: false,
            loading: false,
            size: 'default',
            nostatus: 0,
            noVisible: false
        }
    },
    async created() {
        this.step_user_id = this.i.step_user_id
        // await this.$store.dispatch("Users/getUserlist");
        // this.userLists = this.$store.state.Users.userLists
        // this.outerList = this.userLists.outer
        // this.userList = this.userLists.inner
        // this.userList.map(item => {
        //     if (item.id == this.i.step_user_id) {
        //         this.step_user_name = item.uname
        //     }
        // })
    },
    filters: {
        rCity(val) {
            if (val) {
                let cityArr = val.split(",")
                cityArr.splice(2, 1)
                return cityArr.toString()
            }
        },
    },
    methods: {
        convertToFullwidthBrackets,
        resection(test) {
            if (typeof test === 'string' && test.endsWith('/')) {
                return test.slice(0, -1);
            }
            return test;
        },
        increaseJudgment(lits) {
            if (this.user && this.user.id === 1) {
                return false;
            }
            if (lits.some(item => item && item.user_id === this.user.id)) {
                return false;
            }
            return true;
        },
        AgentShow(name) {
            this.$store.dispatch("openkey", { key: name, by: true })
        },
        litigation() {
            if (this.$common.AccAUTH(this.i.accuser_id, "costs:check")) {
                this.$store.dispatch("setkey", { key: "Edit", value: true })
                this.$store.dispatch("openkey", { key: 'paymentPopUp', by: true })
            } else {
                this.$message.error({ content: '暂无权限', key: 'updatable' });
            }
        },
        setStepUser(value, item) {
            this.step_user_id = value || 0
            this.datas = item
        },
        editstepname() {
            this.stepnameVisible = true
        },
        close() {
            this.stepnameVisible = false
            this.noVisible = false
        },
        confirm() {
            this.disabledShow = true
            causeStStepUser({ cause_id: this.datas.id, user_id: this.step_user_id }).then(e => {
                this.$message.success({ content: '设置成功', key: 'updatable' });
                this.userList.map(item => {
                    if (item.id == this.step_user_id) {
                        this.step_user_name = item.uname
                    }
                })
                this.stepnameVisible = false
                this.disabledShow = false
            })
        },
        markSub() {    //特殊备注修改
            if (!this.note.content) {
                this.$message.error('请输入特殊备注')
                return false;
            }
            if (!this.note.user_id) {
                addNote({ note: this.note.content, cause_id: this.$store.state.cause.id }).then(e => {//新增
                    this.$message.success('已提交审核')
                    this.i.notes.push(e.note)
                    this.noteVisible = false;
                })
            } else {
                modifyNote({
                    note: this.note.content,
                    note_id: this.note.id,
                }).then(e => {
                    const index = this.i.notes.findIndex(item => item.id === e.note.id);
                    if (index !== -1) {
                        this.i.notes[index] = e.note;
                    }

                    this.$message.success('已提交审核')
                    // this.i.notes.push(e.note)
                    this.noteVisible = false;
                })
            }
            // causeEditNote({ note: this.note, id: this.$store.state.cause.id }).then(e => {
            //     this.$message.success('已提交审核')
            //     let caselist = JSON.parse(JSON.stringify(this.caselist))
            //     let audit = caselist[index].audit
            //     audit.push({ field: "note" })
            //     this.$store.dispatch('Case/putInData', { index: index, key: "note", value: this.note })
            //     this.$store.dispatch('Case/putInData', { index: index, key: "audit", value: audit })
            //     this.noteVisible = false;
            // })
        },
        textareaChange(e) {
            this.inputChange = false
        }, isEdit(val, audit) {
            let bool = audit.filter(ele => {
                return val == ele.field
            }).length > 0 ? true : false;
            return bool
        },
        visibleShow(name) {
            if (name == 'paymentPopUp') {
                this.$store.dispatch("setkey", { key: "Edit", value: true })
            }
            this.$store.dispatch("openkey", { key: name, by: true })
        },
        setStepUser1(value, item) {
            item.step_user_id = value || 0;
            causeStStepUser({ cause_id: item.id, user_id: item.step_user_id }).then(e => {
                this.$message.success({ content: '设置成功', key: 'updatable' });
            })
        },
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
        dbclick(record) {
            if (this.$common.AUTH('loan:info:lists')) {
                let routeUrl = this.$router.resolve({ "name": "paybacksee", params: { "id": Number(this.$route.params.id) } });
                window.open(routeUrl.href, '_blank');
            }
            else {
                this.$message.error({ content: '暂无权限', key: 'updatable' });
            }
        },
        collectionClick(record) {
            if (this.$common.AUTH('payee:info:lists')) {
                let routeUrl = this.$router.resolve({ "name": "AmountSee", params: { "id": Number(this.$route.params.id) } });
                window.open(routeUrl.href, '_blank');
            }
            else {
                this.$message.error({ content: '暂无权限', key: 'updatable' });
            }
        },

        noShow(type) {
            this.noVisible = true
            this.nostatus = type
        }
    }
}
</script>
<style scoped>
.rts {
    display: flex;
    gap: 10px;
}

.primary span {
    color: #1d8bfe !important;
}

.primary {
    /* background-color: #a5a5a542 !important; */
}

.default {
    background: #D6D6D8 !important
}

.default span {
    color: #a5a5a5 !important;
}

/* 修改标题框背景色 */
:deep(.custom-descriptions .ant-descriptions-item-label) {
    width: 230px;
    height: 60px;
    background-color: #F6F8FC !important;
    /* 自定义背景色 */
}

/* 可选：优化标题框内边距，避免文字挤边 */
:deep(.custom-descriptions .ant-descriptions-item-label) {
    padding: 12px 16px !important;
}
</style>